module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "portlet light"
  }, [_c('div', {
    staticClass: "module-name"
  }, [_vm._v("Communication Notes")]), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.getLoading) ? _c('vue-spinner') : _c('div', {
    directives: [{
      name: "bar",
      rawName: "v-bar"
    }],
    staticClass: "portlet-body",
    staticStyle: {
      "height": "566px",
      "overflow": "hidden"
    }
  }, [(_vm.showLoop(_vm.user.case_notes)) ? _c('div', {
    staticClass: "general-item-list"
  }, _vm._l((_vm.user.case_notes), function(casenote) {
    return _c('div', {
      staticClass: "item"
    }, [_c('div', {
      staticClass: "item-head"
    }, [(casenote.type === 'referral' || casenote.read_only) ? _c('span', {
      staticStyle: {
        "color": "#d09f23"
      }
    }, [_vm._v("\n            " + _vm._s(_vm.note[casenote.type]))]) : _c('a', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.editNoteAction(casenote)
        }
      }
    }, [_vm._v(_vm._s(_vm.note[casenote.type]) + " ")]), _vm._v(" "), _c('i', {
      staticClass: "fa fa-thumb-tack pin inactivePin",
      class: {
        'activePin': _vm.checkPin(casenote.is_pinned)
      },
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          return _vm.setPin(casenote.id, casenote.is_pinned)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "item-body casenote-title",
      domProps: {
        "innerHTML": _vm._s(_vm.excerpt(casenote.note, 150))
      }
    }), _vm._v(" "), _c('ul', {
      staticClass: "casenotes"
    }, [_c('li', [_c('div', {
      staticClass: "col1"
    }, [_c('div', {
      staticClass: "cont"
    }, [_c('div', {
      staticClass: "cont-col2"
    }, [_c('div', {
      staticClass: "date"
    }, [_vm._v(_vm._s(_vm._f("formatDate")(casenote.createdAt.date)))])])])]), _vm._v(" "), _c('div', {
      staticClass: "col2"
    }, [_c('div', {
      staticClass: "name"
    }, [_vm._v(" " + _vm._s(casenote.createdBy.fullName))])])])])])
  }), 0) : _c('div', [_c('p', [_vm._v("No records available.")])])]), _vm._v(" "), _c('div', {
    staticClass: "btn-arrow-link pull-right"
  }, [(_vm.showLoop(_vm.user.case_notes)) ? _c('a', {
    staticClass: "Link text-warning",
    on: {
      "click": _vm.showAll
    }
  }, [_vm._v("VIEW ALL")]) : _vm._e(), _vm._v(" "), (_vm.showLoop(_vm.user.case_notes) && _vm.logged.access > 2) ? _c('span', [_vm._v("|")]) : _vm._e(), _vm._v(" "), (_vm.logged.access > 2 && _vm.programStatus !== 'Dismissed') ? _c('a', {
    staticClass: "Linkt text-warning",
    on: {
      "click": _vm.addNew
    }
  }, [_vm._v(" NEW ")]) : _vm._e(), _vm._v(" "), (_vm.logged.access > 2 && _vm.programStatus !== 'Dismissed') ? _c('i', {
    staticClass: "icon-arrow-right"
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "case-notes",
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "modal-title uppercase"
  }, [_vm._v("Communication Notes")]), _vm._v(" "), _c('div', {
    staticClass: "actions pull-right"
  }, [_c('a', {
    staticClass: "btn btn-circle btn-icon-only btn-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.downloadReport.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "icon-cloud-download"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "role": "form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSearchNotes.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-body"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-control input-icon"
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Type to search..."
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-control-focus"
  })]), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn btn-right"
  }, [_c('button', {
    ref: "searchBtn",
    staticClass: "btn green mt-ladda-btn ladda-button btn-search",
    attrs: {
      "type": "submit",
      "data-style": "expand-left"
    }
  }, [_c('span', {
    staticClass: "ladda-label"
  }, [_vm._v("Search")])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    directives: [{
      name: "bar",
      rawName: "v-bar"
    }],
    staticClass: "col-md-12",
    staticStyle: {
      "min-height": "400px",
      "overflow": "hidden"
    }
  }, [_c('div', {
    staticClass: "general-item-list"
  }, _vm._l((_vm.allNotes.data), function(casenote) {
    return _c('div', {
      staticClass: "item"
    }, [_c('div', {
      staticClass: "item-head"
    }, [_c('a', {
      attrs: {
        "href": ""
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.editNoteAction(casenote)
        }
      }
    }, [_vm._v(_vm._s(_vm.note[casenote.type]))]), _vm._v(" "), _c('i', {
      staticClass: "fa fa-thumb-tack pin inactivePin",
      class: {
        'activePin': _vm.checkPin(casenote.is_pinned)
      },
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          return _vm.modalSetPin(casenote.id, casenote.is_pinned)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "item-body casenote-title",
      domProps: {
        "innerHTML": _vm._s(casenote.note)
      }
    }), _vm._v(" "), _c('ul', {
      staticClass: "casenotes"
    }, [_c('li', [_c('div', {
      staticClass: "col1"
    }, [_c('div', {
      staticClass: "cont"
    }, [_c('div', {
      staticClass: "cont-col2"
    }, [_c('div', {
      staticClass: "date"
    }, [_vm._v(_vm._s(_vm._f("formatDate")(casenote.createdAt.date)))])])])]), _vm._v(" "), _c('div', {
      staticClass: "col2"
    }, [_c('div', {
      staticClass: "name"
    }, [_vm._v(" " + _vm._s(casenote.createdBy.fullName))])])])])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('pagination', {
    attrs: {
      "page-count": _vm.allNotes.hasOwnProperty('pages') ? _vm.allNotes.pages : 0,
      "page-range": 1,
      "margin-pages": 1,
      "click-handler": _vm.changePage,
      "prev-text": 'Prev',
      "next-text": 'Next',
      "container-class": 'pagination pagination-sm'
    }
  })], 1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "new-case-notes",
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-sm"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Communication Type:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.caseNoteType),
      expression: "caseNoteType"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.caseNoteType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "collateral"
    }
  }, [_vm._v("Collateral Contact")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "person"
    }
  }, [_vm._v("In-Person")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "phone"
    }
  }, [_vm._v("Phone")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "social"
    }
  }, [_vm._v("Social/Messenger")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "text"
    }
  }, [_vm._v("Text")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "virtual"
    }
  }, [_vm._v("Virtual")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Notes:")]), _vm._v(" "), _c('vue-editor', {
    attrs: {
      "editor-toolbar": _vm.customToolbar
    },
    model: {
      value: (_vm.caseNote),
      callback: function($$v) {
        _vm.caseNote = $$v
      },
      expression: "caseNote"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [(_vm.logged.access > 2) ? _c('button', {
    staticClass: "btn green mt-ladda-btn ladda-button add-casenote-control",
    attrs: {
      "data-dismiss": "modal",
      "data-style": "expand-left"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addCase.apply(null, arguments)
      }
    }
  }, [_c('span', {
    staticClass: "ladda-label"
  }, [_vm._v("Save")])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn default",
    attrs: {
      "data-dismiss": "modal"
    }
  }, [_vm._v("Cancel")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "edit-case-notes",
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-sm"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Communication Type:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editNote.type),
      expression: "editNote.type"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editNote, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "collateral"
    }
  }, [_vm._v("Collateral Contact")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "person"
    }
  }, [_vm._v("In-Person")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "phone"
    }
  }, [_vm._v("Phone")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "social"
    }
  }, [_vm._v("Social/Messenger")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "text"
    }
  }, [_vm._v("Text")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "virtual"
    }
  }, [_vm._v("Virtual")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Notes:")]), _vm._v(" "), _c('vue-editor', {
    attrs: {
      "editor-toolbar": _vm.customToolbar
    },
    model: {
      value: (_vm.editNote.note),
      callback: function($$v) {
        _vm.$set(_vm.editNote, "note", $$v)
      },
      expression: "editNote.note"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [(_vm.logged.access > 2) ? _c('button', {
    staticClass: "btn green mt-ladda-btn ladda-button edit-casenote-control",
    attrs: {
      "data-dismiss": "modal",
      "data-style": "expand-left"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.editCase.apply(null, arguments)
      }
    }
  }, [_c('span', {
    staticClass: "ladda-label"
  }, [_vm._v("Save")])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn default",
    attrs: {
      "data-dismiss": "modal"
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.editNote.updatedAt != null) ? _c('div', {
    staticClass: "text-left"
  }, [_c('h4', [_vm._v("ACTIVITY LOGGING")]), _vm._v(" "), _c('p', [_vm._v("Saved: " + _vm._s(_vm.editNote.createdBy.fullName) + " on " + _vm._s(_vm._f("formatDate")(_vm.editNote.createdAt.date)))]), _vm._v(" "), _c('p', [_vm._v("Last Modified: " + _vm._s(_vm.editNote.updatedBy.fullName) + " on " + _vm._s(_vm._f("formatDate")(_vm.editNote.updatedAt.date)) + " ")])]) : _vm._e()])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "portlet-title"
  }, [_c('div', {
    staticClass: "caption caption-md"
  }, [_c('i', {
    staticClass: "icon-bar-chart font-dark hide"
  }), _vm._v(" "), _c('span', {
    staticClass: "caption-subject font-dark bold uppercase"
  }, [_vm._v("Communication Notes")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("ADD COMMUNICATION NOTE")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("EDIT COMMUNICATION NOTE")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c465012","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/CaseNotes.vue
// module id = 1591
// module chunks = 1